routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.detailZone', {
      url: "zona-de-pagos/detalle",
      template: `<detail-zone sh-ctrl="shCtrl"></detail-zone>`
    });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/pay-zone/detail-zone/detail-zone.config.js